import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import { persistStore } from 'redux-persist'
import { history } from './history'
import thunk from 'redux-thunk';
import {persistedReducer} from "./persistence"

export default function configureStore(preloadedState) {
    let store = createStore(
        persistedReducer,
        preloadedState,
        compose(
            applyMiddleware(
                routerMiddleware(history),
                thunk
            ),
        ),
    )
    let persistor =  persistStore(store)
    return {store, persistor}
}